// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"dbc75b08","184":"e9fd9e31","771":"aa7c10a1","950":"7ad09918"}[chunkId] + ".chunk.js";
};